import { render, staticRenderFns } from "./fatture.html?vue&type=template&id=b36e8052&scoped=true&"
import script from "./Fatture.vue?vue&type=script&lang=js&"
export * from "./Fatture.vue?vue&type=script&lang=js&"
import style0 from "./Fatture.vue?vue&type=style&index=0&id=b36e8052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36e8052",
  null
  
)

export default component.exports